<template>
  <v-card class="login">
    <div class="centralizado">
      <img src="../../assets/logoNagro.png" alt="logoNagro" class="img" />
    </div>
    <form @submit.prevent="login()" class="centralizado">
      <v-text-field type="email" v-model="form.email" label="Email" required></v-text-field>
      <v-text-field type="password" v-model="form.password" label="Senha" required></v-text-field>
      <p style="color: red" v-if="mensagem">{{mensagem}}</p>
      <br />
      <br />
      <v-btn color="primary" type="submit">Entrar</v-btn>
    </form>
  </v-card>
</template>


<script>
import Painel from "../../components/Painel.vue";
import api from "../../services/api";

export default {
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      mensagem: ""
    };
  },

  components: {
    "meu-painel": Painel
  },

  methods: {
    login() {
      api
        .post("/sessions", this.form)
        .then(response => {
          localStorage.setItem("usuario", JSON.stringify(response.data.user));
          localStorage.setItem("token", JSON.stringify(response.data.token));
          this.$router.push({ name: "cadastroProdutor" });
        })
        .catch(err => {
          if (err.response.status === 500) {
            alert("Não foi possivel conectar-se ao servidor");
          } else {
            this.mensagem = err.response.data.error;
          }
        });
    }
  },
  watch: {
    mensagem: function() {
      var self = this;
      setTimeout(function() {
        self.mostraMensagem = false;
        self.mensagem = "";
      }, 3000);
    }
  },
  mounted() {
    if (localStorage.getItem("usuario") && localStorage.getItem("token")) {
      this.$router.push({ name: "cadastroProdutor" });
    }
  }
};
</script>

<style>
.centralizado {
  margin-top: -20px;
  text-align: center;
}

.img {
  width: 150px;
  margin-top: 15px;
  height: 150px;
}

@media (min-width: 800px) {
  .login {
    margin: 70px auto 60px auto;
    padding: 0px 50px 50px 50px;
    width: 40%;
  }
}

@media (max-width: 800px) {
  .login {
    margin: 70px auto 60px auto;
    padding: 30px;
    width: 90%;
  }
}
</style>